import {Calculation} from "./calculation";
import {LabMDM} from "./lab";
import {OperetionHistoryDTO} from "./operationHistory";
import {WorkfileDefinitionHeader} from "./workFileDefinitionHeader";

export class Workfile{
    _id: string;
    workFileDefintionName:string;
    lab:LabMDM;
    constantSubstring:string;
    fileFormat:string;
    machineType:string;
    active:boolean;
    processName:string;
    processStepName:string;
    stepDisplayName:string;
    continueWithFileConfig:boolean;
    version : number;
    creationDate: Date;
    lastModifiedDate: Date;
    fileName: string;
    calculations: Calculation[];
    tableDefinition : WorkfileDefinitionHeader[];
    includeHeader :boolean;
    history : OperetionHistoryDTO[];
    reduceToOneRow:boolean;
    fileContentDefinitionType: string;
    plateContentDefinition: PlateContentDefinition = new PlateContentDefinition();
}

export class PlateContentDefinition {
  version: string;
  treatAsVolumes: boolean;
  wellVolume: number;
  reagents: Reagent[] = []
}

class Reagent {
  name: string;
  volume: number;
  index: number;
}
